<template>
  <div class="categorias ui-container">
    <div class="container">
      <ul class="row justify-content-center">
        <li class="col-md-3 col-12">
          <router-link :to="{name: 'Empreendimentos', query: parametros('')}">
            <!-- se colocar a classe active em categorias__box fica com a categoria selecionada -->
            <div class="categorias__box w-100 text-center" :class="{'active': !$route.query.category}">
              Todos
            </div>
          </router-link>
        </li>
        <li class="col-md-3 col-12" v-for="(item,index) in empreendimentosCategorias" :key="index">
          <router-link :to="{name: 'Empreendimentos', query: parametros(item.id)}">
            <div class="categorias__box w-100 text-center" :class="{'active': $route.query.category == item.id}"> {{item.name}} </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script type="text/javascript">
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'empreendimentosCategorias'
    ])
  },
  created () {
    this.$store.dispatch('loadEmpreendimentosCategorias')
  },
  methods: {
    parametros (categoria, filter) {
      let parametros = {}
      if (categoria) {
        parametros.category = categoria
      }
      if (this.$route.query.filter) {
        parametros.filter = this.$route.query.filter
      }
      if (this.$route.query.delivered) {
        parametros.delivered = this.$route.query.delivered
      }
      if (this.$route.query.for_sale) {
        parametros.for_sale = this.$route.query.for_sale
      }
      return parametros
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.categorias {
  background: $bgIntern;
  li {
    margin-bottom: 10px;
    .categorias__box {
      background: white;
      border-radius: 5px;
      box-shadow: 0px 5px 10px 0px rgba(114,114,119, 0.2);
      color: #6f6f6f;
      font-size: 16px;
      padding: 15px 20px;
      transition: all 0.3s;
      &:hover {
        background: $primary;
        color: white;
        font-weight: 600;
        transition: all 0.3s;
      }
    }
    .active {
      background: $primary;
      color: white;
      font-weight: 600;
      overflow: hidden;
      position: relative;
      transition: all 0.3s;
      &:before {
        background: $green;
        bottom: 0px;
        content: '';
        height: 4px;
        left: 0;
        position: absolute;
        transition: all 0.3s;
        width: 100%;
      }
    }
  }
  @media (max-width: 767px) {
    li {
      margin-bottom: 15px;
      &:nth-last-of-type(1) {
        margin-bottom: 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/EmpreendimentosCategorias.vue